<template>
    <section>
        <div class="page-wrap">
            <div class="container checkout">
                <div class="box-content">
                    <share-story hr="below" v-bind:order="orderId"></share-story>
                    <div class="row">
                        <div class="col-md-12">
                            <h4 class="mt-10"><strong>Thank you for becoming a part of D.C. United history and congratulations on commemorating your legacy with a brick in the Audi Field Fanwalk!</strong></h4>
                            <h2>Order Summary</h2>
                            <div>
                                <div class="th hidden-xs">
                                    <div class="row">
                                        <div class="col-sm-3">PRODUCT</div>
                                        <div class="col-xs-9">
                                            <div class="row">
                                                <div class="col-xs-1 text-center">QTY</div>
                                                <div class="col-xs-4 col-md-4">DESCRIPTION</div>
                                                <div class="col-xs-7 col-md-7">SHIPPING ADDRESS (if applicable)</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tb" v-for="(item, itemIndex) in cart">
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <div class="prod-container">
                                                <img v-if="item.gc" class="prod-img" src="images/giftcertificate.png"/>
                                                <template v-else>
                                                    <img class="prod-img" v-bind:src="'images/catalog/' + campaign.short_url + '/' + products[item.item_id].item_image_blank"/>
                                                    <div class="prod-replica cart-img">
                                                        <div class="prod-replica-table">
                                                            <div class="prod-replica-table-td vb">
                                                                <p v-for="n in products[item.item_id].max_lines">{{ item.lines[n-1] }}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="col-sm-9">
                                            <template v-if="item.gc">
                                                <!-- GIFT CERTIFICATE has one shipping address for all items -->
                                                <template v-if="itemIndex in shipItemTo && 'qtys' in shipItemTo[itemIndex]">
                                                    <div class="row tr" v-for="(qty, qtyIndex) in shipItemTo[itemIndex].qtys">
                                                        <div class="col-xs-1 text-center">
                                                            <div class="wrap-count">
                                                                <div class="amount">
                                                                    <span>1</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-html="products[item.item_id].description + ' GIFT CERTIFICATE'" class="col-xs-4 col-md-4"></div>
                                                        <div class="col-xs-7 col-md-7">
                                                            {{ addresses[qty.address_id] | addressToString }}
                                                        </div>
                                                    </div>
                                                    <div class="row tr" v-for="(qty, childId) in cart[itemIndex].children">
                                                        <template v-if="qty > 0">
                                                            <div class="col-xs-1 text-center">
                                                                <div class="wrap-count">
                                                                    <div class="amount">
                                                                        <span>{{ qty }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div v-html="baseProductChildren[childId].description" class="col-xs-4 col-md-4"></div>
                                                            <div class="col-xs-7 col-md-7"></div>
                                                        </template>
                                                    </div>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <!-- a PAVER set can have no shippping address(es) at all -->
                                                <div class="row tr">
                                                    <div class="col-xs-1 text-center">
                                                        <div class="wrap-count">
                                                            <div class="amount">
                                                                <span>1</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-html="products[item.item_id].description" class="col-xs-4 col-md-4"></div>
                                                    <div class="col-xs-7 col-md-7">
                                                        <!-- not shippable -->
                                                    </div>
                                                </div>
                                                <template v-if="itemIndex in shipItemTo && 'qtys' in shipItemTo[itemIndex]">
                                                    <div class="row tr" v-for="(qty, qtyIndex) in shipItemTo[itemIndex].qtys">
                                                        <div class="col-xs-1 text-center">
                                                            <div class="wrap-count">
                                                                <div class="amount">
                                                                    <span>1</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-html="baseProductChildren[qty.item_id].description" class="col-xs-4 col-md-4"></div>
                                                        <div class="col-xs-7 col-md-7">
                                                            {{ addresses[qty.address_id] | addressToString }}
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-right">
                                    <div class="total">Subtotal:
                                        <span class="wrap">
                                            <span class="pull-left">$&nbsp;</span>{{ subTotal.toFixed(2) }}
                                        </span>
                                    </div>
                                    <div class="total">Sales&nbsp;Tax:
                                        <span class="wrap">
                                            <span class="pull-left">$&nbsp;</span>{{ salesTax.toFixed(2) }}
                                        </span>
                                    </div>
                                    <div class="total" v-if="isConvenienceFeeAllowed">Web Convenience&nbsp;Fee:
                                        <span class="wrap">
                                            <span class="pull-left">$&nbsp;</span>{{ convenienceFee.toFixed(2) }}
                                        </span>
                                    </div>
                                    <strong class="subtotal">Order&nbsp;Total:
                                        <span>$&nbsp;</span>{{ orderTotal.toFixed(2) }}
                                    </strong>
                                </div>
                                <hr>
                                <h2>Order Confirmation</h2>
                                <div>
                                    <p>Please note: you will receive an email order confirmation detailing your order and important review instructions.
                                        This will be in your email. We recommend checking your spam or junk folder if this is your first time ordering.
                                    </p>
                                    <p>The location of all engraved bricks will be determined at the discretion of D.C. United.</p>
                                    <p>Please print for your records.</p>
                                    <a class="btn btn-outline-danger btn-lg" v-on:click="onPrintReceipt">Print Receipt</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    import store from '../store'
    import { mapState, mapGetters } from 'vuex'
    // mixins
    import CampaignConfigurationMixin from '../../../../assets/js/components/frontend/mixin/campaign-configuration.vue'
    import OrderCreationMixin from '@/components/mixin/order-creation.vue'

    import ShareStory from '@/components/ShareStory.vue';
    export default {
        name: 'confirmation',
        mixins: [
            CampaignConfigurationMixin,
            OrderCreationMixin,
            require('../../../../assets/js/components/frontend/mixin/filters.vue')
        ],
        components: {
            'share-story': ShareStory
        },
        beforeRouteEnter (to, from, next) {
            if (from.name === 'Checkout' && store.getters.isOrderCompleted) {
                next();
            } else {
                next({ name: 'Checkout' });
            }
        },
        beforeRouteLeave (to, from, next) {
            store.commit('clearCompletedOrder');
            next();
        },
        computed: {
            ...mapState([
                'campaign', 'orderId'
            ]),
            ...mapGetters([
                'products', 'childProducts', 'cart',
                'hasShippableItems', 'subTotal', 'taxableAmount',
                'shipItemTo', 'addresses'
            ]),
            ...mapGetters({
                baseProductChildren: 'baseProductShippableChildren'
            }),
        },
        methods: {
            onPrintReceipt: function () {
                window.print()
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Confirmation.vue?74755c58